const Chart = {
  /**
   * Create behaviour for storing the form on the server with AJAX
   * @param {HTMLElement} node
   * @return {void}
   */
  create(node) {
    this.node = node;

    if (typeof window.FrappeChart === 'undefined') {
      throw new Error('FrappeChart library is not available');
    }

    this.retrieveChartInformation((err, data) => {
      if (err) { throw new Error(err); }
      this.buildChart(data);
    });
  },

  /**
   * Retrieve chart data
   * @param {Function} cb
   * @return {Promise}
   */
  retrieveChartInformation(cb) {
    const api = this.node.getAttribute('data-chart-api');

    if (!api) {
      return cb('No API url given');
    }

    return window.axios.get(api)
      .then((res) => {
        cb(null, res.data);
      });
  },

  /**
   * Get data attribute for element
   * @param {String} key
   * @return {String}
   */
  getDataAttr(key) {
    return this.node.getAttribute(`data-${key}`);
  },

  /**
   * Create chart with FrappeChart
   * @param {Object} data
   * @return {Object}
   */
  buildChart(data) {
    return new window.FrappeChart(this.node, data);
  },
};

export default Chart;
